export const LANG_LOCAL_STORAGE = "LANG";
export const JA = "ja";
export const EN = "en";
export const REFRESH_TOKEN_LOCAL_STORAGE = "refresh";
export const PRINCIPAL = "principal";
export const TEACHER = "staff";
export const OPEN_NAV = "open_nav";
export const NEW = "new";
export const STUDENT = "student";
export const LICENSED_SCHOOL_LABEL = "_facility_form._licensed_nursery_school";
export const AUTHORIZED_SCHOOL_LABEL =
  "_facility_form._certified_childcare_center";
export const SMALL_SCHOOL_LABEL = "_facility_form._small-scale_nursery_school";
export const NONLICENSED_SCHOOL_LABEL =
  "_facility_form._unlicensed_nursery_school";
export const KINDERGARTEN_LABEL = "_facility_form._kindergarten";
export const COMPANY_LED_SCHOOL_LABEL =
  "_facility_form._company-operated_nursery_school";
export const AFTERSCHOOL_SCHOOL_LABEL = "_facility_form._primary_school";
export const ELEMENTARY_SCHOOL_LABEL = "_facility_form._elementary_school";
export const CRAM_SCHOOL_LABEL = "_facility_form._cram_school";
export const LEISURE_SCHOOL_LABEL = "_facility_form._extracurricular_school";
export const MIDDLE_SCHOOL_LABEL = "_facility_form._junior_high_school";
export const OTHER_SCHOOL_LABEL = "_facility_form._other";
export const FREE_TRAIL_LABEL = "トライアル";
export const CONTRACT_LABEL = "契約";
export const CANCELLED_LABEL = "解約";
export const USER_MANUAL_CATEGORY_LOCAL_STORAGE = "user_manual_category";
export const USER_MANUAL_LOCAL_STORAGE = "user_manual";
